var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}function ownKeys(object, enumerableOnly) {var keys = Object.keys(object);if (Object.getOwnPropertySymbols) {var symbols = Object.getOwnPropertySymbols(object);enumerableOnly && (symbols = symbols.filter(function (sym) {return Object.getOwnPropertyDescriptor(object, sym).enumerable;})), keys.push.apply(keys, symbols);}return keys;}function _objectSpread(target) {for (var i = 1; i < arguments.length; i++) {var source = null != arguments[i] ? arguments[i] : {};i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {_defineProperty(target, key, source[key]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));});}return target;}function _defineProperty(obj, key, value) {if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}import React, { useEffect, useState } from 'react';
import { Field } from 'react-redux-form';
import { connect } from 'react-redux';
import { orderBy } from 'lodash';
import { Select } from "../../ReactReduxForms";
import { Translate, t } from "../../I18N";
import { Warning } from "../../Layout";


import PropertyConfigOptions from "./PropertyConfigOptions";
import { checkErrorsOnLabel } from "../utils/checkErrorsOnLabel";






const mapStateToProps = (state, ownProps) => {
  const { template, thesauris } = state;
  const property = template.data.properties ? template.data.properties[ownProps.index] : undefined;
  return {
    labelHasError: checkErrorsOnLabel(state, ownProps),
    contentRequiredError:
    //@ts-ignore
    template.formState.$form.errors[`properties.${ownProps.index}.content.required`],
    templateId: template.data._id,
    thesauris,
    property,
    content: property === null || property === void 0 ? void 0 : property.content,
    index: ownProps.index,
    type: ownProps.type
  };
};

const connector = connect(mapStateToProps);



const FormConfigSelectComponent = ({
  index,
  type,
  labelHasError,
  contentRequiredError,
  templateId,
  property,
  content,
  thesauris
}) => {
  const [warning, setWarning] = useState(false);
  const [initialContent] = useState(content);

  useEffect(() => {
    if (initialContent !== content && property !== null && property !== void 0 && property._id) {
      setWarning(true);
    }
  }, [content]);

  const options = orderBy(
  thesauris.
  toJS().
  filter(
  (thesaurus) =>
  thesaurus._id !== templateId && thesaurus.type !== 'template').

  map((thesaurus) => _objectSpread(_objectSpread({},
  thesaurus), {}, {
    name: t(thesaurus._id, thesaurus.name, null, false) })),

  'name');


  return /*#__PURE__*/(
    _jsx("div", {}, void 0, /*#__PURE__*/
    _jsx("div", { className: `form-group${labelHasError ? ' has-error' : ''}` }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Label")), /*#__PURE__*/

    _jsx(Field, { model: `template.data.properties[${index}].label` }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control", id: "property-label" }))), /*#__PURE__*/



    _jsx("div", { className: "form-group" }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-type" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Type")), /*#__PURE__*/

    _jsx("span", { className: "property-type-warning" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "This cannot be changed after saving")), /*#__PURE__*/

    _jsx(Field, { model: `template.data.properties[${index}].type` }, void 0, /*#__PURE__*/
    _jsx("select", {
      name: "type",
      id: "property-type",
      className: "form-control",
      disabled: !!(property !== null && property !== void 0 && property._id) }, void 0, /*#__PURE__*/

    _jsx("option", { value: "select" }, void 0, t('System', 'Single select', null, false)), /*#__PURE__*/
    _jsx("option", { value: "multiselect" }, void 0, t('System', 'Multiple select', null, false))))), /*#__PURE__*/




    _jsx("div", { className: contentRequiredError ? 'form-group has-error' : 'form-group' }, void 0, /*#__PURE__*/
    _jsx("label", { htmlFor: "property-thesauri" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Thesauri"), /*#__PURE__*/
    _jsx("span", { className: "required" }, void 0, "*")),

    warning && /*#__PURE__*/
    _jsx(Warning, { inline: true }, void 0, /*#__PURE__*/
    _jsx(Translate, { translationKey: "Impact of property change warning" }, void 0, "All entities and documents that have already this property assigned will loose its current value")), /*#__PURE__*/





    _jsx(Select, {
      model: `template.data.properties[${index}].content`,
      options: options,
      optionsLabel: "name",
      optionsValue: "_id",
      id: "property-thesauri" })), /*#__PURE__*/



    _jsx(PropertyConfigOptions, { index: index, type: type })));


};

const container = connector(FormConfigSelectComponent);
export { container as FormConfigSelect };